import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import LoginPage from '@/components/users/LoginPage'
import HomePage from '@/components/HomePage'
import UserList from '@/components/users/UserList'
import SchoolList from '@/components/schools/SchoolList'
import SubjectList from '@/components/subjects/SubjectList'
import GroupList from '@/components/subjects/GroupList'
import GradeList from '@/components/subjects/GradeList'
import ApprovalSubjects from '@/components/subjects/ApprovalSubjects'
import StudentList from '@/components/students/StudentList'
import StudentDetail from '@/components/students/StudentDetail'
import DCList from '@/components/dynamic-content/DCList'
import ChatList from '@/components/chats/ChatList'
import Dashboard from '@/components/Dashboard'
import ImportUsersCsv from '@/components/students/ImportUsersCsv'
import ImportCoursesCsv from '@/components/subjects/ImportCoursesCsv'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/lessons',
      name: 'Lessons',
      component: HomePage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        public: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/schools',
      name: 'SchoolList',
      component: SchoolList
    },
    {
      path: '/subjects',
      name: 'SubjectList',
      component: SubjectList
    },
    {
      path: '/groups',
      name: 'GroupList',
      component: GroupList
    },
    {
      path: '/grades',
      name: 'GradeList',
      component: GradeList
    },
    {
      path: '/approval-subjects',
      name: 'ApprovalSubjects',
      component: ApprovalSubjects
    },
    {
      path: '/students',
      name: 'StudentList',
      component: StudentList
    },
    {
      path: '/students/:id',
      name: 'StudentDetail',
      component: StudentDetail,
      props: true
    },
    {
      path: '/dynamic-content',
      name: 'DCList',
      component: DCList
    },
    {
      path: '/chats',
      name: 'ChatList',
      component: ChatList
    },
    {
      path: '/import-users-csv',
      name: 'ImportUsersCsv',
      component: ImportUsersCsv
    },
    {
      path: '/import-courses-csv',
      name: 'ImportCoursesCsv',
      component: ImportCoursesCsv
    },

    // otherwise redirect to home
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ['/login']
  // const authRequired = !publicPages.includes(to.path)
  // const loggedIn = Vue.prototype.$auth ? Vue.prototype.$auth.isAuthenticated() : false

  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(
    record => record.meta.onlyWhenLoggedOut
  )
  const loggedIn = Vue.prototype.$auth
    ? Vue.prototype.$auth.isAuthenticated()
    : false

  if (!isPublic && !loggedIn) {
    // localStorage.setItem('refererLogin', to.name)
    store.commit('setRefererRouteLogin', to.name)
    return next({
      path: '/login',
      query: {
        redirect: to.fullPath
      } // Store the full path to redirect the user to after login
    })
  } else if (!store.state.refererRouteLogin) {
    store.commit('setRefererRouteLogin', 'HomePage')
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js